var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouseMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 2V16",
    stroke: "#5B5FC7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 4L34 2L36 4",
    stroke: "#5B5FC7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14L34 16L36 14",
    stroke: "#5B5FC7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 9H27",
    stroke: "#5B5FC7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39 7L41 9L39 11",
    stroke: "#5B5FC7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 7L27 9L29 11",
    stroke: "#5B5FC7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 24.5C21.75 23.6716 21.0784 23 20.25 23C19.4216 23 18.75 23.6716 18.75 24.5V29C18.75 29.8284 19.4216 30.5 20.25 30.5C21.0784 30.5 21.75 29.8284 21.75 29V24.5Z",
    fill: "#424242"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 26C7.5 20.201 12.201 15.5 18 15.5H22.5C28.299 15.5 33 20.201 33 26V38C33 43.799 28.299 48.5 22.5 48.5H18C12.201 48.5 7.5 43.799 7.5 38V26ZM18 18.5H22.5C26.6421 18.5 30 21.8579 30 26V38C30 42.1421 26.6421 45.5 22.5 45.5H18C13.8579 45.5 10.5 42.1421 10.5 38V26C10.5 21.8579 13.8579 18.5 18 18.5Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseMove);
export default __webpack_public_path__ + "static/media/Mouse-move.35fee36098e6b40463a22a7e9abb60ae.svg";
export { ForwardRef as ReactComponent };